import styled from 'styled-components';
import CardDetailsInline from '@anm/components/credit-card/CardDetailsInline';
import { media } from '@anm/styles/helpers';

export const SubscriptionHistoryItemRow = styled.div<{
  isActive: boolean;
}>`
  border-bottom: 1px solid rgba(145, 158, 170, 0.3);
  padding: 30px 0;
  display: flex;
  &:first-of-type {
    border-top: 1px solid rgba(145, 158, 170, 0.3);
  }
  color: ${({ isActive }) => (isActive ? 'initial' : 'rgba(145,158,170,1)')};
`;

const HistoryItemChildMobileStyle = media.phone`
  flex: auto;
  margin: 0 5px;
`;

const SubscriptionHistoryCardDetailsTablet = media.desktop_small`
  display: none;
`;

const InvoiceLinkWrapperTablet = media.desktop_small`
  flex: 1;
`;

export const SubscriptionHistoryCardDetails = styled(CardDetailsInline)`
  ${SubscriptionHistoryCardDetailsTablet};
`;

export const PaymentFailedMessage = styled.span`
  border-bottom: 1px dashed #919eaa;
  cursor: pointer;
`;
export const DateView = styled.div`
  margin-right: 20px;
  flex: 0 1 175px;
  ${HistoryItemChildMobileStyle};
`;
export const Amount = styled.div`
  margin-left: 70px;
  flex: 0 1 110px;
  ${HistoryItemChildMobileStyle};
`;
export const InvoiceLinkWrapper = styled.div`
  text-align: right;
  flex: 0 1 140px;
  ${InvoiceLinkWrapperTablet};
  ${HistoryItemChildMobileStyle};
`;
